import { render, staticRenderFns } from "./DraftStudentModal.vue?vue&type=template&id=38d68cf0&"
import script from "./DraftStudentModal.vue?vue&type=script&lang=js&"
export * from "./DraftStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./DraftStudentModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports